import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-KQXWGV',
        },
    },
    host: 'www.zalando-lounge.co.uk',
});
